import { FC } from 'react';
import intl from 'react-intl-universal';
import { tailwindOverride, Typography } from '@getsynapse/design-system';
import { PROJECT_HEALTH } from 'utils/constants/projectsList';
import type { ProjectHealth as ProjectHealthType } from 'utils/types/projectsList';

const healthMapping: Record<
  ProjectHealthType,
  { color: string; label: string }
> = {
  [PROJECT_HEALTH.OFF_TRACK]: {
    color: 'bg-error-dark',
    label: 'PROJECT_DETAIL.HEALTH_OPTIONS.OFF_TRACK',
  },
  [PROJECT_HEALTH.ON_TRACK]: {
    color: 'bg-success',
    label: 'PROJECT_DETAIL.HEALTH_OPTIONS.ON_TRACK',
  },
  [PROJECT_HEALTH.AT_RISK]: {
    color: 'bg-warning-light',
    label: 'PROJECT_DETAIL.HEALTH_OPTIONS.AT_RISK',
  },
};

interface ProjectHealthProps {
  health: ProjectHealthType;
  className?: string;
  indicatorClassName?: string;
  labelClassName?: string;
}

const ProjectHealth: FC<ProjectHealthProps> = ({
  health,
  className,
  indicatorClassName,
  labelClassName,
}) => {
  if (!health) return null;
  const { color, label } = healthMapping[health];
  return (
    <div className={tailwindOverride('flex items-center', className)}>
      <div
        className={tailwindOverride(
          'w-2 h-2 rounded-full mr-3',
          color,
          indicatorClassName
        )}
      />
      <Typography variant='label' className={tailwindOverride(labelClassName)}>
        {intl.get(label)}
      </Typography>
    </div>
  );
};

export default ProjectHealth;
